// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-module_btn__Yc2iG {
    /* size */
    --cw-btn-width: auto;
    --cw-btn-max-width: auto;
    --cw-btn-height: auto;
    --cw-btn-max-height: auto;
    /* border & radius */
    --cw-btn-radius: 4px;
    --cw-btn-border-width: 0px;
    /* typography */
    --cw-btn-font-family: inherit;
    --cw-btn-font-weight: inherit;
    --cw-btn-font-size: inherit;
    --cw-btn-line-height: normal;
    --cw-btn-letter-spacing: normal;
    --cw-btn-text-align: center;
    --cw-btn-max-lines: initial;
    /* elevation */
    --cw-btn-elevation: 0;
    /* icon */
    --cw-btn-icon-size: 24px;
    --cw-btn-gap: 8px;
    /* spacing */
    --cw-btn-margin-top: 0;
    --cw-btn-margin-right: 0;
    --cw-btn-margin-bottom: 0;
    --cw-btn-margin-left: 0;
    --cw-btn-padding-top: 0;
    --cw-btn-padding-right: 0;
    --cw-btn-padding-bottom: 0;
    --cw-btn-padding-left: 0;
    /* default state */
    --cw-btn-color: inherit;
    --cw-btn-bg: transparent;
    --cw-btn-border-color: transparent;
    /* hover */
    --cw-btn-color-hover: inherit;
    --cw-btn-bg-hover: transparent;
    --cw-btn-border-color-hover: transparent;
    /* active */
    --cw-btn-color-active: inherit;
    --cw-btn-bg-active: transparent;
    --cw-btn-border-color-active: transparent;
    /* disabled */
    --cw-btn-color-disabled: #999;
    --cw-btn-bg-disabled: transparent;
    --cw-btn-border-color-disabled: transparent;
    --cw-btn-cursor-disabled: not-allowed;

    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: var(--cw-btn-text-align);
    gap: var(--cw-btn-gap);
    box-sizing: border-box;
    cursor: pointer;
    text-decoration: none;
    width: var(--cw-btn-width);
    max-width: var(--cw-btn-max-width);
    height: var(--cw-btn-height);
    max-height: var(--cw-btn-max-height);
    font-family: var(--cw-btn-font-family), sans-serif;
    font-weight: var(--cw-btn-font-weight);
    font-size: var(--cw-btn-font-size);
    line-height: var(--cw-btn-line-height);
    letter-spacing: var(--cw-btn-letter-spacing);
    overflow: hidden;
    -webkit-line-clamp: var(--cw-btn-max-lines);
    border-radius: var(--cw-btn-radius, 4px);
    border: var(--cw-btn-border-width) solid var(--cw-btn-border-color);
    color: var(--cw-btn-color);
    background: var(--cw-btn-bg);
    box-shadow: var(--cw-btn-box-shadow, 0 calc(var(--cw-btn-elevation) * 0.5px) calc(var(--cw-btn-elevation) * 2px) rgba(0, 0, 0, 0.2));
    padding: var(--cw-btn-padding-top) var(--cw-btn-padding-right) var(--cw-btn-padding-bottom) var(--cw-btn-padding-left);
    margin: var(--cw-btn-margin-top) var(--cw-btn-margin-right) var(--cw-btn-margin-bottom) var(--cw-btn-margin-left);
    transition:
        background-color 0.2s,
        color 0.2s,
        border-color 0.2s,
        box-shadow 0.2s,
        width var(--cw-btn-width-transition, 0s);
    pointer-events: auto;
}

/* Touch browsers emulate a sticky :hover after a tap/long press — apply hover only for real pointers. */
@media (hover: hover) and (pointer: fine) {
    .button-module_btn__Yc2iG:not(:disabled):hover {
        color: var(--cw-btn-color-hover);
        background: var(--cw-btn-bg-hover);
        border-color: var(--cw-btn-border-color-hover);
    }
}

.button-module_btn__Yc2iG:not(:disabled):active {
    color: var(--cw-btn-color-active);
    background: var(--cw-btn-bg-active);
    border-color: var(--cw-btn-border-color-active);
}

.button-module_btn__Yc2iG:disabled {
    cursor: var(--cw-btn-cursor-disabled);
    color: var(--cw-btn-color-disabled);
    background: var(--cw-btn-bg-disabled);
    border-color: var(--cw-btn-border-color-disabled);
}

/* Layout modifiers */
.button-module_fullWidth__QJ7K9 {
    width: 100%;
}

.button-module_fitContent__pC7ZT {
    width: fit-content;
}

.button-module_hidden__zQKxC {
    display: none;
}

/* Alignment */
.button-module_alignTopLeft__UJF02 {
    position: relative;
    top: 0;
    left: 0;
}
.button-module_alignTopCenter__eaLNB {
    position: relative;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
}
.button-module_alignTopRight__uVzPl {
    position: relative;
    top: 0;
    right: 0;
}
.button-module_alignCenterLeft__eKccO {
    position: relative;
    top: 50%;
    left: 0;
}
.button-module_alignCenter__OTYKY {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
}
.button-module_alignCenterRight__CGIL8 {
    position: relative;
    top: 50%;
    right: 0;
}
.button-module_alignBottomLeft__ZKMXD {
    position: relative;
    bottom: 0;
    left: 0;
}
.button-module_alignBottomCenter__tAsPg {
    position: relative;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
}
.button-module_alignBottomRight__O2XoN {
    position: relative;
    bottom: 0;
    right: 0;
}

.button-module_icon___iZjt {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    width: var(--cw-btn-icon-size);
    height: var(--cw-btn-icon-size);
}
`, "",{"version":3,"sources":["webpack://./../../packages/core-widgets/src/button/button.module.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,oBAAoB;IACpB,wBAAwB;IACxB,qBAAqB;IACrB,yBAAyB;IACzB,oBAAoB;IACpB,oBAAoB;IACpB,0BAA0B;IAC1B,eAAe;IACf,6BAA6B;IAC7B,6BAA6B;IAC7B,2BAA2B;IAC3B,4BAA4B;IAC5B,+BAA+B;IAC/B,2BAA2B;IAC3B,2BAA2B;IAC3B,cAAc;IACd,qBAAqB;IACrB,SAAS;IACT,wBAAwB;IACxB,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB,uBAAuB;IACvB,uBAAuB;IACvB,yBAAyB;IACzB,0BAA0B;IAC1B,wBAAwB;IACxB,kBAAkB;IAClB,uBAAuB;IACvB,wBAAwB;IACxB,kCAAkC;IAClC,UAAU;IACV,6BAA6B;IAC7B,8BAA8B;IAC9B,wCAAwC;IACxC,WAAW;IACX,8BAA8B;IAC9B,+BAA+B;IAC/B,yCAAyC;IACzC,aAAa;IACb,6BAA6B;IAC7B,iCAAiC;IACjC,2CAA2C;IAC3C,qCAAqC;;IAErC,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,yCAAyC;IACzC,sBAAsB;IACtB,sBAAsB;IACtB,eAAe;IACf,qBAAqB;IACrB,0BAA0B;IAC1B,kCAAkC;IAClC,4BAA4B;IAC5B,oCAAoC;IACpC,kDAAkD;IAClD,sCAAsC;IACtC,kCAAkC;IAClC,sCAAsC;IACtC,4CAA4C;IAC5C,gBAAgB;IAChB,2CAA2C;IAC3C,wCAAwC;IACxC,mEAAmE;IACnE,0BAA0B;IAC1B,4BAA4B;IAC5B,oIAAoI;IACpI,sHAAsH;IACtH,iHAAiH;IACjH;;;;;gDAK4C;IAC5C,oBAAoB;AACxB;;AAEA,wGAAwG;AACxG;IACI;QACI,gCAAgC;QAChC,kCAAkC;QAClC,8CAA8C;IAClD;AACJ;;AAEA;IACI,iCAAiC;IACjC,mCAAmC;IACnC,+CAA+C;AACnD;;AAEA;IACI,qCAAqC;IACrC,mCAAmC;IACnC,qCAAqC;IACrC,iDAAiD;AACrD;;AAEA,qBAAqB;AACrB;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA,cAAc;AACd;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,2BAA2B;AAC/B;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;AACZ;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,OAAO;AACX;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;AAC/B;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;AACZ;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;AACX;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;AAC/B;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,8BAA8B;IAC9B,+BAA+B;AACnC","sourcesContent":[".btn {\n    /* size */\n    --cw-btn-width: auto;\n    --cw-btn-max-width: auto;\n    --cw-btn-height: auto;\n    --cw-btn-max-height: auto;\n    /* border & radius */\n    --cw-btn-radius: 4px;\n    --cw-btn-border-width: 0px;\n    /* typography */\n    --cw-btn-font-family: inherit;\n    --cw-btn-font-weight: inherit;\n    --cw-btn-font-size: inherit;\n    --cw-btn-line-height: normal;\n    --cw-btn-letter-spacing: normal;\n    --cw-btn-text-align: center;\n    --cw-btn-max-lines: initial;\n    /* elevation */\n    --cw-btn-elevation: 0;\n    /* icon */\n    --cw-btn-icon-size: 24px;\n    --cw-btn-gap: 8px;\n    /* spacing */\n    --cw-btn-margin-top: 0;\n    --cw-btn-margin-right: 0;\n    --cw-btn-margin-bottom: 0;\n    --cw-btn-margin-left: 0;\n    --cw-btn-padding-top: 0;\n    --cw-btn-padding-right: 0;\n    --cw-btn-padding-bottom: 0;\n    --cw-btn-padding-left: 0;\n    /* default state */\n    --cw-btn-color: inherit;\n    --cw-btn-bg: transparent;\n    --cw-btn-border-color: transparent;\n    /* hover */\n    --cw-btn-color-hover: inherit;\n    --cw-btn-bg-hover: transparent;\n    --cw-btn-border-color-hover: transparent;\n    /* active */\n    --cw-btn-color-active: inherit;\n    --cw-btn-bg-active: transparent;\n    --cw-btn-border-color-active: transparent;\n    /* disabled */\n    --cw-btn-color-disabled: #999;\n    --cw-btn-bg-disabled: transparent;\n    --cw-btn-border-color-disabled: transparent;\n    --cw-btn-cursor-disabled: not-allowed;\n\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    justify-content: var(--cw-btn-text-align);\n    gap: var(--cw-btn-gap);\n    box-sizing: border-box;\n    cursor: pointer;\n    text-decoration: none;\n    width: var(--cw-btn-width);\n    max-width: var(--cw-btn-max-width);\n    height: var(--cw-btn-height);\n    max-height: var(--cw-btn-max-height);\n    font-family: var(--cw-btn-font-family), sans-serif;\n    font-weight: var(--cw-btn-font-weight);\n    font-size: var(--cw-btn-font-size);\n    line-height: var(--cw-btn-line-height);\n    letter-spacing: var(--cw-btn-letter-spacing);\n    overflow: hidden;\n    -webkit-line-clamp: var(--cw-btn-max-lines);\n    border-radius: var(--cw-btn-radius, 4px);\n    border: var(--cw-btn-border-width) solid var(--cw-btn-border-color);\n    color: var(--cw-btn-color);\n    background: var(--cw-btn-bg);\n    box-shadow: var(--cw-btn-box-shadow, 0 calc(var(--cw-btn-elevation) * 0.5px) calc(var(--cw-btn-elevation) * 2px) rgba(0, 0, 0, 0.2));\n    padding: var(--cw-btn-padding-top) var(--cw-btn-padding-right) var(--cw-btn-padding-bottom) var(--cw-btn-padding-left);\n    margin: var(--cw-btn-margin-top) var(--cw-btn-margin-right) var(--cw-btn-margin-bottom) var(--cw-btn-margin-left);\n    transition:\n        background-color 0.2s,\n        color 0.2s,\n        border-color 0.2s,\n        box-shadow 0.2s,\n        width var(--cw-btn-width-transition, 0s);\n    pointer-events: auto;\n}\n\n/* Touch browsers emulate a sticky :hover after a tap/long press — apply hover only for real pointers. */\n@media (hover: hover) and (pointer: fine) {\n    .btn:not(:disabled):hover {\n        color: var(--cw-btn-color-hover);\n        background: var(--cw-btn-bg-hover);\n        border-color: var(--cw-btn-border-color-hover);\n    }\n}\n\n.btn:not(:disabled):active {\n    color: var(--cw-btn-color-active);\n    background: var(--cw-btn-bg-active);\n    border-color: var(--cw-btn-border-color-active);\n}\n\n.btn:disabled {\n    cursor: var(--cw-btn-cursor-disabled);\n    color: var(--cw-btn-color-disabled);\n    background: var(--cw-btn-bg-disabled);\n    border-color: var(--cw-btn-border-color-disabled);\n}\n\n/* Layout modifiers */\n.fullWidth {\n    width: 100%;\n}\n\n.fitContent {\n    width: fit-content;\n}\n\n.hidden {\n    display: none;\n}\n\n/* Alignment */\n.alignTopLeft {\n    position: relative;\n    top: 0;\n    left: 0;\n}\n.alignTopCenter {\n    position: relative;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n}\n.alignTopRight {\n    position: relative;\n    top: 0;\n    right: 0;\n}\n.alignCenterLeft {\n    position: relative;\n    top: 50%;\n    left: 0;\n}\n.alignCenter {\n    position: relative;\n    top: 50%;\n    left: 50%;\n    transform: translateX(-50%);\n}\n.alignCenterRight {\n    position: relative;\n    top: 50%;\n    right: 0;\n}\n.alignBottomLeft {\n    position: relative;\n    bottom: 0;\n    left: 0;\n}\n.alignBottomCenter {\n    position: relative;\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n}\n.alignBottomRight {\n    position: relative;\n    bottom: 0;\n    right: 0;\n}\n\n.icon {\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n    width: var(--cw-btn-icon-size);\n    height: var(--cw-btn-icon-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn": `button-module_btn__Yc2iG`,
	"fullWidth": `button-module_fullWidth__QJ7K9`,
	"fitContent": `button-module_fitContent__pC7ZT`,
	"hidden": `button-module_hidden__zQKxC`,
	"alignTopLeft": `button-module_alignTopLeft__UJF02`,
	"alignTopCenter": `button-module_alignTopCenter__eaLNB`,
	"alignTopRight": `button-module_alignTopRight__uVzPl`,
	"alignCenterLeft": `button-module_alignCenterLeft__eKccO`,
	"alignCenter": `button-module_alignCenter__OTYKY`,
	"alignCenterRight": `button-module_alignCenterRight__CGIL8`,
	"alignBottomLeft": `button-module_alignBottomLeft__ZKMXD`,
	"alignBottomCenter": `button-module_alignBottomCenter__tAsPg`,
	"alignBottomRight": `button-module_alignBottomRight__O2XoN`,
	"icon": `button-module_icon___iZjt`
};
export default ___CSS_LOADER_EXPORT___;
